<script setup lang="ts">
  import { computed } from 'vue'
  import {
    CalendarIcon,
    MessageCircleIcon,
    MailIcon,
    PhoneIcon,
    ClipboardCheckIcon,
    UserIcon,
    FileTextIcon
  } from 'lucide-vue-next'
  import { cn } from '@/lib/utils'

  const props = defineProps<{
    type: string
    class?: string
  }>()

  const typeConfig = computed(() => {
    switch (props.type) {
      case 'API':
        return {
          color: 'bg-blue-100 text-blue-700 border border-blue-200',
          icon: FileTextIcon,
          label: 'API'
        }
      case 'CHAT BOT':
        return {
          color: 'bg-purple-100 text-purple-700 border border-purple-200',
          icon: MessageCircleIcon,
          label: 'Chatbot'
        }
      case 'QUESTIONNAIRE':
        return {
          color: 'bg-amber-100 text-amber-700 border border-amber-200',
          icon: ClipboardCheckIcon,
          label: 'Fragebogen'
        }
      case 'EMAIL':
        return {
          color: 'bg-orange-100 text-orange-700 border border-orange-200',
          icon: MailIcon,
          label: 'E-Mail'
        }
      case 'MANUAL':
        return {
          color: 'bg-gray-100 text-gray-700 border border-gray-200',
          icon: UserIcon,
          label: 'Manuell'
        }
      case 'PHONE':
        return {
          color: 'bg-green-100 text-green-700 border border-green-200',
          icon: PhoneIcon,
          label: 'Anruf'
        }
      case 'APPOINTMENT':
        return {
          color: 'bg-blue-100 text-blue-700 border border-blue-200',
          icon: CalendarIcon,
          label: 'Termin'
        }
      default:
        return {
          color: 'bg-gray-100 text-gray-700 border border-gray-200',
          icon: FileTextIcon,
          label: props.type
        }
    }
  })
</script>

<template>
  <div
    :class="
      cn(
        'inline-flex h-7 items-center rounded-md px-3 py-1.5 text-sm font-medium',
        typeConfig.color,
        props.class
      )
    "
  >
    <component
      :is="typeConfig.icon"
      class="mr-1.5 h-4 w-4"
    />
    {{ typeConfig.label }}
  </div>
</template>
